﻿import { Injectable } from '@angular/core';

import {  HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

import { Observable } from 'rxjs';
import { map, tap, mergeMap, pluck } from 'rxjs/operators';

import { CitationService } from './citation.service';

import { AssayDetails } from '../_models';

import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AssayMetadataService {

  constructor(
    private http2: HttpClient,
    private citationSvc: CitationService,
  ) { }


  retrieveAssayList(aid: string): Observable<any> {
    return this.http2.get('https://crestdb.org/api/assay_details', {
      observe: 'response',
      headers: new HttpHeaders()
        .set('Accept', 'application/json'),
      params: new HttpParams()
        .set('aid', aid)
    }).pipe(
      pluck("body"),
      mergeMap(assayDetails => this.citationSvc.getCitation([assayDetails[0].bibliography]).pipe(
      map(citations => {
        let assayMetadata = assayDetails[0];
        assayMetadata['citations'] = citations;

        return(assayMetadata);
      })
    )
  )

    )

  }
}
